/**
 * 🏆 배지 시스템 정의
 * The STAFF 앱의 게이미피케이션 배지 목록
 */

// 배지 카테고리 (3D 정적 아이콘 포함)
export const BADGE_CATEGORIES = {
    FIRST_STEPS: { id: 'first_steps', name: '첫 걸음', emoji: '🌱', color: 'emerald', icon: '/images/Seedling.png' },
    PASTORAL: { id: 'pastoral', name: '목양의 길', emoji: '💖', color: 'rose', icon: '/images/Heart_on_fire_static.png' },
    NURTURING: { id: 'nurturing', name: '양육', emoji: '👨‍👩‍👧‍👦', color: 'blue', icon: '/images/Heart_hands_static.png' },
    CONSISTENCY: { id: 'consistency', name: '성실함', emoji: '📅', color: 'amber', icon: '/images/Calendar.png' },
    CELEBRATION: { id: 'celebration', name: '축하', emoji: '🎂', color: 'pink', icon: '/images/birthday_cake_animated.png' },
    ATTENDANCE: { id: 'attendance', name: '출석', emoji: '✅', color: 'green', icon: '/images/Check_mark_button.png' },
    FINANCE: { id: 'finance', name: '재정', emoji: '💰', color: 'yellow', icon: '/images/Money_bag.png' },
    CHEER: { id: 'cheer', name: '격려', emoji: '💝', color: 'rose', icon: '/images/Growing_heart.png' }, // [NEW] 격려 카테고리
    SPECIAL: { id: 'special', name: '특별', emoji: '✨', color: 'purple', icon: '/images/Sparkles.png' },
    HIDDEN: { id: 'hidden', name: '히든', emoji: '🔒', color: 'gray', icon: '/images/Gear.png' }
};

// 🎨 배지별 3D 애니메이션 이모지 이미지 경로 매핑
// 파일명은 public/images/badges/ 폴더에 저장
export const BADGE_ICONS = {
    // ===== 첫 걸음 시리즈 =====
    first_student: '/images/Waving_hand.png',           // 👋 필요
    first_visit: '/images/Envelope.png',                // 💌 있음
    first_attendance: '/images/Raising_hands.png',      // ✋ 있음
    first_schedule: '/images/Calendar.png',             // 📅 있음
    first_finance: '/images/Dollar_banknote.png',       // 💵 있음
    first_teacher: '/images/Handshake.png',             // 🤝 필요

    // ===== 목양의 길 시리즈 =====
    visit_10: '/images/Footprints.png',                 // 👣 필요
    visit_30: '/images/Ewe.png',                        // 🐑 있음
    visit_50: '/images/Gem_stone.png',                  // 💎 필요
    visit_100: '/images/Medal.png',                     // 🏅 필요
    prayer_10: '/images/prayer_3d.png',                 // 🙏 있음
    call_20: '/images/Telephone_Receiver.png',          // 📞 있음
    fellowship_10: '/images/Hot_beverage.png',          // ☕ 있음
    interview_20: '/images/Memo.png',                   // 📝 있음

    // ===== 양육 시리즈 =====
    student_5: '/images/House.png',                     // 🏠 있음
    student_10: '/images/Heart_hands.png',              // 👨‍👩‍👧 Heart_hands로 대체
    student_20: '/images/Seedling.png',                 // 🌳 Seedling 대체
    student_30: '/images/Student.png',                  // 👨‍👩‍👧‍👦 Student로 대체
    student_50: '/images/Grapes.png',                   // 🍇 필요
    student_100: '/images/Sparkles.png',                // ✨ 있음

    // [NEW] 교사 시리즈
    teacher_5: '/images/Teacher.png',                   // 🧑‍🏫 교사 이미지
    teacher_10: '/images/Thumbs_up.png',                // 👍 따봉으로 변경 (기존: Briefcase)
    // let's use Teacher for 5.
    teacher_20: '/images/Crown.png',                    // 👑 Crown (streak_100에서 사용중이지만 중복 가능)

    // ===== 성실함 시리즈 =====
    streak_3: '/images/Fire.png',                       // 🔥 있음
    streak_7: '/images/Flexed_biceps.png',              // 💪 있음
    streak_14: '/images/Glowing_star.png',              // ⭐ 있음
    streak_30: '/images/Glowing_star.png',              // 🌟 있음 (같은거 사용)
    streak_100: '/images/Crown.png',                    // 👑 있음
    streak_365: '/images/Trophy.png',                   // 🏆 필요

    // ===== 축하 시리즈 =====
    birthday_5: '/images/Wrapped_gift.png',             // 🎁 있음
    birthday_20: '/images/Party_popper.png',            // 🎉 있음
    birthday_visit_10: '/images/Party_popper.png',      // 🎊 있음 (같은거 사용)

    // ===== 출석 시리즈 =====
    attendance_10: '/images/Clipboard.png',             // 📋 있음
    attendance_50: '/images/Check_mark_button.png',     // ✔️ 있음
    attendance_100: '/images/Bar_chart.png',            // 📊 있음
    perfect_week: '/images/Hundred_points.png',         // 💯 필요

    // ===== 재정 시리즈 =====
    finance_10: '/images/Clipboard.png',                // 📒 있음 (대체)
    finance_50: '/images/Money_bag.png',                // 💼 있음 (대체)
    budget_keeper: '/images/Shield.png',                // 🛡️ 필요

    // ===== 특별 시리즈 =====
    early_bird: '/images/Sun.png',                      // 🌅 있음 (대체)
    night_owl: '/images/Crescent_moon.png',             // 🌙 있음
    christmas: '/images/Christmas_tree.png',            // 🎄 필요
    easter: '/images/Hatching_chick.png',               // 🐣 필요
    thanksgiving: '/images/Fallen_leaf.png',            // 🍂 필요
    one_year: '/images/spiral_calendar_animated.png',   // 🗓️ 있음
    two_years: '/images/Gem_stone.png',                 // 💎 필요
    team_leader: '/images/Busts_in_silhouette.png',     // 👥 필요
    explorer: '/images/Magnifying_glass.png',           // 🔍 필요

    // ===== 히든 시리즈 =====
    speedster: '/images/Rocket.png',                    // 🚀 필요
    devoted_shepherd: '/images/Heart_on_fire.png',      // 💝 있음
    completionist_first: '/images/Glowing_star.png',    // ⭐ 있음
    night_shepherd: '/images/Owl.png',                  // 🦉 필요

    // ===== [NEW] 격려 시리즈 =====
    first_cheer: '/images/Growing_heart.png',           // 💝 첫 격려
    cheer_10: '/images/Revolving_hearts.png',           // 💖 격려 10회
    cheer_50: '/images/Love_letter.png',                // 💕 격려 50회
    cheer_master: '/images/Heart_on_fire.png'           // 💞 격려 마스터
};

// 전체 배지 목록
export const BADGES = [
    // ==================== 🌱 첫 걸음 시리즈 ====================
    {
        id: 'first_student',
        name: '첫 만남',
        description: '첫 번째 학생을 등록했어요',
        emoji: '👋',
        category: 'first_steps',
        condition: { type: 'student_count', value: 1 },
        rarity: 'common',
        points: 10
    },
    {
        id: 'first_visit',
        name: '첫 목양',
        description: '첫 번째 심방 기록을 남겼어요',
        emoji: '💌',
        category: 'first_steps',
        condition: { type: 'visit_count', value: 1 },
        rarity: 'common',
        points: 10
    },
    {
        id: 'first_attendance',
        name: '첫 출석',
        description: '첫 출석 체크를 했어요',
        emoji: '✋',
        category: 'first_steps',
        condition: { type: 'attendance_count', value: 1 },
        rarity: 'common',
        points: 10
    },
    {
        id: 'first_schedule',
        name: '첫 일정',
        description: '첫 번째 일정을 등록했어요',
        emoji: '📅',
        category: 'first_steps',
        condition: { type: 'schedule_count', value: 1 },
        rarity: 'common',
        points: 10
    },
    {
        id: 'first_finance',
        name: '첫 재정',
        description: '첫 번째 재정 기록을 남겼어요',
        emoji: '💵',
        category: 'first_steps',
        condition: { type: 'finance_count', value: 1 },
        rarity: 'common',
        points: 10
    },
    {
        id: 'first_teacher',
        name: '첫 동역자',
        description: '첫 번째 교사를 등록했어요',
        emoji: '🤝',
        category: 'first_steps',
        condition: { type: 'teacher_count', value: 1 },
        rarity: 'common',
        points: 10
    },

    // ==================== 💖 목양의 길 시리즈 ====================
    {
        id: 'visit_10',
        name: '한 걸음 더',
        description: '심방 10회를 달성했어요',
        emoji: '👣',
        category: 'pastoral',
        condition: { type: 'visit_count', value: 10 },
        rarity: 'common',
        points: 50
    },
    {
        id: 'visit_30',
        name: '목자의 마음',
        description: '심방 30회를 달성했어요',
        emoji: '🐑',
        category: 'pastoral',
        condition: { type: 'visit_count', value: 30 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'visit_50',
        name: '목양 베테랑',
        description: '심방 50회를 달성했어요',
        emoji: '💎',
        category: 'pastoral',
        condition: { type: 'visit_count', value: 50 },
        rarity: 'rare',
        points: 200
    },
    {
        id: 'visit_100',
        name: '헌신의 증거',
        description: '심방 100회를 달성했어요',
        emoji: '🏅',
        category: 'pastoral',
        condition: { type: 'visit_count', value: 100 },
        rarity: 'epic',
        points: 500
    },
    {
        id: 'prayer_10',
        name: '기도의 사람',
        description: '기도 심방 10회를 달성했어요',
        emoji: '🙏',
        category: 'pastoral',
        condition: { type: 'visit_type_count', visitType: '기도', value: 10 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'call_20',
        name: '소통의 달인',
        description: '전화/문자 심방 20회를 달성했어요',
        emoji: '📞',
        category: 'pastoral',
        condition: { type: 'visit_type_count', visitType: ['전화', '문자'], value: 20 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'fellowship_10',
        name: '교제의 열매',
        description: '교제 심방 10회를 달성했어요',
        emoji: '☕',
        category: 'pastoral',
        condition: { type: 'visit_type_count', visitType: '교제', value: 10 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'interview_20',
        name: '면담 전문가',
        description: '면담 심방 20회를 달성했어요',
        emoji: '📝',
        category: 'pastoral',
        condition: { type: 'visit_type_count', visitType: '면담', value: 20 },
        rarity: 'uncommon',
        points: 100
    },

    // ==================== 👨‍👩‍👧‍👦 양육 시리즈 ====================
    {
        id: 'student_5',
        name: '가정의 시작',
        description: '학생 5명을 등록했어요',
        emoji: '🏠',
        category: 'nurturing',
        condition: { type: 'student_count', value: 5 },
        rarity: 'common',
        points: 30
    },
    {
        id: 'student_10',
        name: '작은 공동체',
        description: '학생 10명을 등록했어요',
        emoji: '👨‍👩‍👧',
        category: 'nurturing',
        condition: { type: 'student_count', value: 10 },
        rarity: 'common',
        points: 50
    },
    {
        id: 'student_20',
        name: '성장하는 부서',
        description: '학생 20명을 등록했어요',
        emoji: '🌳',
        category: 'nurturing',
        condition: { type: 'student_count', value: 20 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'student_30',
        name: '대가족',
        description: '학생 30명을 등록했어요',
        emoji: '👨‍👩‍👧‍👦',
        category: 'nurturing',
        condition: { type: 'student_count', value: 30 },
        rarity: 'rare',
        points: 200
    },
    {
        id: 'student_50',
        name: '풍성한 열매',
        description: '학생 50명을 등록했어요',
        emoji: '🍇',
        category: 'nurturing',
        condition: { type: 'student_count', value: 50 },
        rarity: 'epic',
        points: 500
    },
    {
        id: 'student_100',
        name: '선한 목자',
        description: '학생 100명을 등록했어요',
        emoji: '✨',
        category: 'nurturing',
        condition: { type: 'student_count', value: 100 },
        rarity: 'legendary',
        points: 1000
    },

    // [NEW] 교사 시리즈 (양육 카테고리 포함)
    {
        id: 'teacher_5',
        name: '작은 팀',
        description: '교사 5명을 등록했어요',
        emoji: '🌱',
        category: 'nurturing',
        condition: { type: 'teacher_count', value: 5 },
        rarity: 'common',
        points: 30
    },
    {
        id: 'teacher_10',
        name: '든든한 동역',
        description: '교사 10명을 등록했어요',
        emoji: '👍',
        category: 'nurturing',
        condition: { type: 'teacher_count', value: 10 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'teacher_20',
        name: '리더십 공동체',
        description: '교사 20명을 등록했어요',
        emoji: '👑',
        category: 'nurturing',
        condition: { type: 'teacher_count', value: 20 },
        rarity: 'rare',
        points: 300
    },

    // ==================== 📅 성실함 시리즈 ====================
    {
        id: 'streak_3',
        name: '꾸준한 시작',
        description: '3일 연속 접속했어요',
        emoji: '🔥',
        category: 'consistency',
        condition: { type: 'streak_days', value: 3 },
        rarity: 'common',
        points: 20
    },
    {
        id: 'streak_7',
        name: '일주일의 힘',
        description: '7일 연속 접속했어요',
        emoji: '💪',
        category: 'consistency',
        condition: { type: 'streak_days', value: 7 },
        rarity: 'common',
        points: 50
    },
    {
        id: 'streak_14',
        name: '한결같이',
        description: '14일 연속 접속했어요',
        emoji: '⭐',
        category: 'consistency',
        condition: { type: 'streak_days', value: 14 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'streak_30',
        name: '습관의 달인',
        description: '30일 연속 접속했어요',
        emoji: '🌟',
        category: 'consistency',
        condition: { type: 'streak_days', value: 30 },
        rarity: 'rare',
        points: 300
    },
    {
        id: 'streak_100',
        name: '변함없는 동역자',
        description: '100일 연속 접속했어요',
        emoji: '👑',
        category: 'consistency',
        condition: { type: 'streak_days', value: 100 },
        rarity: 'epic',
        points: 1000
    },
    {
        id: 'streak_365',
        name: '전설의 시작',
        description: '365일 연속 접속했어요',
        emoji: '🏆',
        category: 'consistency',
        condition: { type: 'streak_days', value: 365 },
        rarity: 'legendary',
        points: 5000
    },

    // ==================== 🎂 축하 시리즈 ====================
    {
        id: 'birthday_5',
        name: '축복 전달자',
        description: '생일 학생에게 관심을 5번 보여줬어요',
        emoji: '🎁',
        category: 'celebration',
        condition: { type: 'birthday_view_count', value: 5 },
        rarity: 'common',
        points: 50
    },
    {
        id: 'birthday_20',
        name: '파티 플래너',
        description: '생일 학생에게 관심을 20번 보여줬어요',
        emoji: '🎉',
        category: 'celebration',
        condition: { type: 'birthday_view_count', value: 20 },
        rarity: 'uncommon',
        points: 150
    },
    {
        id: 'birthday_visit_10',
        name: '축하 마스터',
        description: '생일 학생에게 심방 10회 했어요',
        emoji: '🎊',
        category: 'celebration',
        condition: { type: 'birthday_visit_count', value: 10 },
        rarity: 'rare',
        points: 300
    },

    // ==================== ✅ 출석 시리즈 ====================
    {
        id: 'attendance_10',
        name: '출석부 시작',
        description: '출석 체크 10회를 달성했어요',
        emoji: '📋',
        category: 'attendance',
        condition: { type: 'attendance_count', value: 10 },
        rarity: 'common',
        points: 30
    },
    {
        id: 'attendance_50',
        name: '열심히 체크',
        description: '출석 체크 50회를 달성했어요',
        emoji: '✔️',
        category: 'attendance',
        condition: { type: 'attendance_count', value: 50 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'attendance_100',
        name: '출석의 달인',
        description: '출석 체크 100회를 달성했어요',
        emoji: '📊',
        category: 'attendance',
        condition: { type: 'attendance_count', value: 100 },
        rarity: 'rare',
        points: 300
    },
    {
        id: 'perfect_week',
        name: '완벽한 주',
        description: '주간 출석률 100%를 달성했어요',
        emoji: '💯',
        category: 'attendance',
        condition: { type: 'perfect_attendance_week', value: 1 },
        rarity: 'rare',
        points: 200
    },

    // ==================== 💰 재정 시리즈 ====================
    {
        id: 'finance_10',
        name: '알뜰살뜰',
        description: '재정 기록 10회를 달성했어요',
        emoji: '📒',
        category: 'finance',
        condition: { type: 'finance_count', value: 10 },
        rarity: 'common',
        points: 30
    },
    {
        id: 'finance_50',
        name: '재정 전문가',
        description: '재정 기록 50회를 달성했어요',
        emoji: '💼',
        category: 'finance',
        condition: { type: 'finance_count', value: 50 },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'budget_keeper',
        name: '예산 수호자',
        description: '연 예산 내에서 한 해를 마무리했어요',
        emoji: '🛡️',
        category: 'finance',
        condition: { type: 'budget_success', value: 1 },
        rarity: 'epic',
        points: 500
    },

    // ==================== ✨ 특별 시리즈 ====================
    {
        id: 'early_bird',
        name: '새벽 기도자',
        description: '새벽 5시 이전에 접속했어요',
        emoji: '🌅',
        category: 'special',
        condition: { type: 'time_access', hour: { before: 5 } },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'night_owl',
        name: '밤의 목양자',
        description: '밤 11시 이후에 접속했어요',
        emoji: '🌙',
        category: 'special',
        condition: { type: 'time_access', hour: { after: 23 } },
        rarity: 'uncommon',
        points: 100
    },
    {
        id: 'christmas',
        name: '성탄 감사',
        description: '12월 25일에 접속했어요 🎄',
        emoji: '🎄',
        category: 'special',
        condition: { type: 'date_access', month: 12, day: 25 },
        rarity: 'rare',
        points: 200
    },
    {
        id: 'easter',
        name: '부활의 기쁨',
        description: '부활절에 접속했어요',
        emoji: '🐣',
        category: 'special',
        condition: { type: 'easter_access' },
        rarity: 'rare',
        points: 200
    },
    {
        id: 'thanksgiving',
        name: '추수 감사',
        description: '추수감사절에 접속했어요',
        emoji: '🍂',
        category: 'special',
        condition: { type: 'thanksgiving_access' },
        rarity: 'rare',
        points: 200
    },
    {
        id: 'one_year',
        name: '한 해의 동역자',
        description: '1년간 앱을 사용했어요',
        emoji: '🗓️',
        category: 'special',
        condition: { type: 'usage_days', value: 365 },
        rarity: 'epic',
        points: 1000
    },
    {
        id: 'two_years',
        name: '2년 동행',
        description: '2년간 앱을 사용했어요',
        emoji: '💎',
        category: 'special',
        condition: { type: 'usage_days', value: 730 },
        rarity: 'legendary',
        points: 3000
    },
    {
        id: 'team_leader',
        name: '팀 리더',
        description: '팀을 생성하고 초대를 완료했어요',
        emoji: '👥',
        category: 'special',
        condition: { type: 'team_created_with_invite' },
        rarity: 'rare',
        points: 500
    },
    {
        id: 'explorer',
        name: '비밀 탐험가',
        description: '숨겨진 기능을 발견했어요',
        emoji: '🔍',
        category: 'special',
        condition: { type: 'secret_found' },
        rarity: 'rare',
        points: 150
    },

    // ==================== 🔒 히든 시리즈 ====================
    {
        id: 'speedster',
        name: '번개손',
        description: '동시에 10명 출석 체크를 했어요',
        emoji: '🚀',
        category: 'hidden',
        condition: { type: 'bulk_attendance', value: 10 },
        rarity: 'rare',
        points: 300,
        hidden: true
    },
    {
        id: 'devoted_shepherd',
        name: '헌신된 목자',
        description: '같은 학생에게 100번 심방했어요',
        emoji: '💝',
        category: 'hidden',
        condition: { type: 'single_student_visits', value: 100 },
        rarity: 'legendary',
        points: 1000,
        hidden: true
    },
    {
        id: 'completionist_first',
        name: '첫 걸음 마스터',
        description: '모든 첫 걸음 배지를 획득했어요',
        emoji: '⭐',
        category: 'hidden',
        condition: { type: 'category_complete', category: 'first_steps' },
        rarity: 'epic',
        points: 500,
        hidden: true
    },
    {
        id: 'night_shepherd',
        name: '심야 목자',
        description: '자정에 심방 기록을 남겼어요',
        emoji: '🦉',
        category: 'hidden',
        condition: { type: 'midnight_visit' },
        rarity: 'rare',
        points: 200,
        hidden: true
    },

    // ==================== 💝 격려 시리즈 ====================
    {
        id: 'first_cheer',
        name: '첫 격려',
        description: '첫 번째 격려 메시지를 보냈어요',
        emoji: '💝',
        category: 'cheer',
        condition: { type: 'cheer_sent_count', value: 1 },
        rarity: 'common',
        points: 15
    },
    {
        id: 'cheer_10',
        name: '따뜻한 마음',
        description: '격려 메시지를 10회 보냈어요',
        emoji: '💖',
        category: 'cheer',
        condition: { type: 'cheer_sent_count', value: 10 },
        rarity: 'uncommon',
        points: 50
    },
    {
        id: 'cheer_50',
        name: '격려의 천사',
        description: '격려 메시지를 50회 보냈어요',
        emoji: '💕',
        category: 'cheer',
        condition: { type: 'cheer_sent_count', value: 50 },
        rarity: 'rare',
        points: 150
    },
    {
        id: 'cheer_master',
        name: '사랑의 전도사',
        description: '격려 메시지를 100회 보냈어요',
        emoji: '💞',
        category: 'cheer',
        condition: { type: 'cheer_sent_count', value: 100 },
        rarity: 'epic',
        points: 300
    }
];

// 희귀도 설정
export const RARITY_CONFIG = {
    common: {
        name: '일반',
        color: 'gray',
        bgColor: 'bg-gray-100',
        textColor: 'text-gray-600',
        borderColor: 'border-gray-300',
        gradient: 'from-gray-100 to-gray-200'
    },
    uncommon: {
        name: '희귀',
        color: 'green',
        bgColor: 'bg-green-100',
        textColor: 'text-green-600',
        borderColor: 'border-green-300',
        gradient: 'from-green-100 to-emerald-200'
    },
    rare: {
        name: '레어',
        color: 'blue',
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-600',
        borderColor: 'border-blue-300',
        gradient: 'from-blue-100 to-cyan-200'
    },
    epic: {
        name: '에픽',
        color: 'purple',
        bgColor: 'bg-purple-100',
        textColor: 'text-purple-600',
        borderColor: 'border-purple-300',
        gradient: 'from-purple-100 to-pink-200'
    },
    legendary: {
        name: '전설',
        color: 'amber',
        bgColor: 'bg-amber-100',
        textColor: 'text-amber-600',
        borderColor: 'border-amber-400',
        gradient: 'from-amber-200 to-yellow-300'
    }
};

// 헬퍼 함수들
export const getBadgeById = (id) => BADGES.find(b => b.id === id);
export const getBadgesByCategory = (categoryId) => BADGES.filter(b => b.category === categoryId);
export const getVisibleBadges = () => BADGES.filter(b => !b.hidden);
export const getHiddenBadges = () => BADGES.filter(b => b.hidden);
export const getRarityConfig = (rarity) => RARITY_CONFIG[rarity] || RARITY_CONFIG.common;
